import style from '../yeah.module.scss'
import { InView } from "react-intersection-observer"
import animations from '@styles/animations.module.scss'
import Image from 'next/image';

interface IFilterSectionProps {
    title: string;
    subtitle: string;
    imageSrc: string;
    imageAlt: string;
}

const FilterSectionYeah = ({ title, subtitle, imageSrc, imageAlt }: IFilterSectionProps) => {
    return (
        <section className={`${style.section} ${style.section_px80}`}>
            <div className={`${style.container} ${style.filter}`}>
                <InView triggerOnce={true}>
                    {({ inView, ref, entry }: any) => {
                        if (inView) {
                            entry?.target.classList.add(animations.active);
                        }
                        return (
                            <div ref={ref} className={`${style.title} ${animations.scroll__animation} ${style.title_middle} ${style.text_align_c} ${style.mb24}`}>
                                {title}
                            </div>
                        )
                    }}
                </InView>
                <InView triggerOnce={true}>
                    {({ inView, ref, entry }: any) => {
                        if (inView) {
                            entry?.target.classList.add(animations.active);
                        }
                        return (
                            <div ref={ref} className={`${style.text} ${animations.scroll__animation} ${style.text_middle} ${style.filter__subtitle} ${style.text_align_c}`}>
                                {subtitle}
                            </div>
                        )
                    }}
                </InView>
                <InView triggerOnce={true}>
                    {({ inView, ref, entry }: any) => {
                        if (inView) {
                            entry?.target.classList.add(animations.active);
                        }
                        return (
                            <div ref={ref} className={`${style.image} ${animations.scroll__animation} ${style.image_filter}`}>
                                <Image src={imageSrc} alt={imageAlt} layout={'fill'} />
                            </div>
                        )
                    }}
                </InView>
            </div>
        </section>
    )
}

export default FilterSectionYeah;
